import { BASE_PATH } from "@/constants/app.mjs"
import { PhoneMockup } from "../../../../common/PhoneMockup"

export function BinanceIntegration() {
  return (
    <div className="pt-6">
      <div className="relative flex items-start justify-center">
        {/* Left phone - smaller, tucked behind */}
        <div className="relative z-0 -mr-6 opacity-90 mt-[30px]">
          <PhoneMockup height={757}>
            <img
              src={`/${BASE_PATH}static/images/marketing/products/partners/binance-2.jpg`}
              alt="Token Terminal on Binance"
              className="w-full h-full object-contain object-top bg-black"
            />
          </PhoneMockup>
        </div>

        {/* Center phone - full size, in front */}
        <div className="relative z-10">
          <PhoneMockup height={864}>
            <img
              src={`/${BASE_PATH}static/images/marketing/products/partners/binance.jpg`}
              alt="Token Terminal on Binance"
              className="w-full h-full object-contain object-top bg-black"
            />
          </PhoneMockup>
        </div>

        {/* Right phone - smaller, tucked behind */}
        <div className="relative z-0 -ml-6 opacity-90 mt-[30px]">
          <PhoneMockup height={757}>
            <img
              src={`/${BASE_PATH}static/images/marketing/products/partners/binance-3.jpg`}
              alt="Token Terminal on Binance"
              className="w-full h-full object-contain object-top bg-black"
            />
          </PhoneMockup>
        </div>
      </div>
    </div>
  )
}
